import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web.drivingzone-training/web.drivingzone-training/node_modules/next/dist/client/app-dir/link.js");
